import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::confirm
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:24
* @route '/api/v1/mini-app/session/confirm'
*/
export const confirm = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

confirm.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/session/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::confirm
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:24
* @route '/api/v1/mini-app/session/confirm'
*/
confirm.url = (options?: RouteQueryOptions) => {
    return confirm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::confirm
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:24
* @route '/api/v1/mini-app/session/confirm'
*/
confirm.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::confirm
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:24
* @route '/api/v1/mini-app/session/confirm'
*/
const confirmForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: confirm.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::confirm
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:24
* @route '/api/v1/mini-app/session/confirm'
*/
confirmForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: confirm.url(options),
    method: 'post',
})

confirm.form = confirmForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::decline
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:33
* @route '/api/v1/mini-app/session/decline'
*/
export const decline = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: decline.url(options),
    method: 'post',
})

decline.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/session/decline',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::decline
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:33
* @route '/api/v1/mini-app/session/decline'
*/
decline.url = (options?: RouteQueryOptions) => {
    return decline.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::decline
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:33
* @route '/api/v1/mini-app/session/decline'
*/
decline.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: decline.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::decline
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:33
* @route '/api/v1/mini-app/session/decline'
*/
const declineForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: decline.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppSessionController::decline
* @see app/Http/Controllers/Api/V1/MiniAppSessionController.php:33
* @route '/api/v1/mini-app/session/decline'
*/
declineForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: decline.url(options),
    method: 'post',
})

decline.form = declineForm

const session = {
    confirm: Object.assign(confirm, confirm),
    decline: Object.assign(decline, decline),
}

export default session